import {store} from '../../../store/store';

export const pay = function (count, count_month, course_name, course_id, tariff_name, amount, teacher_type, user_id, email, name, vk_id, stock, is_first, promo, manager, source, action, func_success = null, func_error = null, is_prepay = false, level_description = '') {
  // eslint-disable-next-line no-undef
  if (window.cp === void 0) func_error('connect_error', undefined);
  let widget = new cp.CloudPayments();

  let title = '';
  let description = ``;

  switch (is_first) {
    case true:
      description = `Покупка полугодового курса. Кол-во уровней: ${count_month}. Тариф: ${tariff_name}.`;
      break;

    case 16:
      if (is_prepay) title = 'Доплата. Полугодовой курс';
      else title = 'Повышение тарифа. Полугодовой курс';
      description = `${title}. Кол-во уровней: ${count_month ?? count}. Тариф: ${tariff_name}.`;
      break;

    case 32:
      description = `Повышение тарифа. Полугодовой курс. Начиная с ${count} уровня ваш тариф «${tariff_name}».`;
      break;

    default:
      description = `Покупка уровня. Полугодовой курс. Уровень: ${level_description}. Тариф: ${tariff_name}.`;
  }

  const payKeys = store.state.payKeys; // ключи для оплат

  widget.charge({ // options
      publicId: (store.state.auth.other.is_tester) ? (payKeys.testKey) : (payKeys.productionKeys.pgk.cloudpayments.publicId), // PUBLIC_ID
      description: description,
      amount: amount, //сумма
      currency: 'RUB', //валюта
      accountId: user_id, //идентификатор плательщика (необязательно)
      email: email,  // Email
      requireEmail: true,
      skin: "classic", //дизайн виджета
      data: {
        name: name, // Имя пользователя
        nick: `https://vk.com/id${vk_id}`, // Ссылка на страницу в вк
        comment: description, // ТУТ ОПИСАНИЕ ПОКУПКИ
        payload: { //произвольный набор параметров,
          teacher_type,
          count,
          user_id,
          course_id,
          stock,
          action,
          is_first,
          promo,
          manager,
          source,
          count_month,
        }
      },
    },
    function (options) { // success
      // действие при успешной оплате
      if (typeof func_success === 'function')
        func_success(course_id, count, options);
    },
    function (reason, options) { // fail
      // действие при неуспешной оплате
      if (typeof func_error === 'function') {
        // debug code

        /*debugPayments({
          type: 2, // тип дебага / 1 - выполняется до платежной функции / 2 - выполняется при ошибке
          fileName: 'payMethodGK.js',
          functionName: 'payMethodGK',
          data: {
            description: description,
            amount: amount, //сумма
            currency: 'RUB', //валюта
            accountId: user_id, //идентификатор плательщика (необязательно)
            email: email,  // Email
            requireEmail: true,
            skin: "classic", //дизайн виджета
            data: {
              name: name, // Имя пользователя
              nick: `https://vk.com/id${vk_id}`, // Ссылка на страницу в вк
              comment: description, // ТУТ ОПИСАНИЕ ПОКУПКИ
              payload: { //произвольный набор параметров
                teacher_type,
                count,
                user_id,
                course_id,
                stock,
                action,
                is_first,
                manager,
                promo,
                source,
                lesson_id
              }
            },
          },
          url: JSON.stringify(window.location),
          userAgent: navigator.userAgent,
          reason: reason,
          options: options,
        });*/

        func_error(reason, options);
      }
    }
  );
}